import React from 'react'
import MaterialSymbol from '../material-symbol'

const Favorite = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="favorite" fill={0} {...props} />
))

Favorite.displayName = 'Favorite'

export default Favorite
